import React, { Fragment, useState } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import Icon from '../../../../components/Icon/Icon';
import CustomControl from '../../../../components/CustomControl/CustomControl';

const formats = ['xls', 'xml', 'csv'];

const StatisticsExport = ({
  exportFields,
  handleExportXLS,
  handleExportXML,
  handleExportCSV,
  toggleFieldsState,
}) => {
  const [isOpen, setOpenState] = useState(false);
  const [type, setType] = useState('xls');

  const toggleModal = () => setOpenState(!isOpen);

  const onChange = ({ target = {} }) => setType(target.value);

  const exportHandlers = {
    xls: handleExportXLS,
    xml: handleExportXML,
    csv: handleExportCSV,
  };

  return (
    <Fragment>
      <Button color="primary" outline className="statistics-export-btn" onClick={toggleModal}>
        <Icon type="download" />
        <FormattedMessage id="statistics.export.button.theme_3" defaultMessage="Download" />
      </Button>

      <Modal isOpen={isOpen} toggle={toggleModal} autoFocus className="statistics-export-modal">
        <ModalHeader toggle={toggleModal}>
          <FormattedMessage
            id="statistics.export.modal.title"
            defaultMessage="Data export to file"
          />
        </ModalHeader>
        <ModalBody>
          <div className="statistics-export-formats">
            <p className="statistics-export-formats-title">
              <FormattedMessage
                id="statistics.export.modal.formats.title"
                defaultMessage="File type for export"
              />
            </p>
            <div className="statistics-export-formats-row">
              {formats.map(format => (
                <CustomControl
                  id={`export-${format}`}
                  key={`statistics-export-${format}`}
                  name="exportFormat"
                  type="radio"
                  className="custom-control-xs"
                  value={format}
                  onChange={onChange}
                  checked={type === format}
                  inline
                >
                  {format}
                </CustomControl>
              ))}
            </div>
          </div>

          <div className="statistics-export-fields">
            <p className="statistics-export-fields-title">
              <FormattedMessage
                id="statistics.export.modal.fields.title"
                defaultMessage="Columns for export"
              />
            </p>
            {exportFields}

            <div className="statistics-export-fields-buttons">
              <Button size="sm" color="primary" onClick={toggleFieldsState.bind(null, true)}>
                <FormattedMessage
                  id="statistics.export.modal.buttons.select_all"
                  defaultMessage="Select all fields"
                />
              </Button>

              <Button
                size="sm"
                color="primary"
                outline
                onClick={toggleFieldsState.bind(null, false)}
              >
                <FormattedMessage
                  id="statistics.export.modal.buttons.select_none"
                  defaultMessage="Remove selection"
                />
              </Button>
            </div>
          </div>
        </ModalBody>
        <ModalFooter className="text-right">
          <Button color="primary" outline onClick={toggleModal}>
            <FormattedMessage id="statistics.export.modal.buttons.close" defaultMessage="Close" />
          </Button>
          <Button color="primary" onClick={exportHandlers[type]}>
            <FormattedMessage
              id="statistics.export.modal.buttons.export"
              defaultMessage="Data export"
            />
          </Button>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
};

export default StatisticsExport;
